import { ERROR_MESSAGE } from "@on-site/constants/errorMessage";
import { z } from "zod";

export const patientNoSchema = z.object({
  patientNo: z
    .string({ required_error: ERROR_MESSAGE.REQUIRED("患者番号") })
    .max(13, "13文字以下で入力してください")
    .min(1, ERROR_MESSAGE.REQUIRED("患者番号"))
    .regex(/^\d+$/, { message: ERROR_MESSAGE.ONLY("半角数字") }),
});

export type PatientNoSchema = z.infer<typeof patientNoSchema>;
